import {
  PaymentLineItemType,
  PaymentLineItemTypeEnum,
  PaymentPlan,
  PaymentPlanEnum,
  PaymentRequestStatus,
  PaymentRequestStatusEnum,
} from "@cruisen/contract"
import { _t } from "@cruisen/i18n"

export const getAgeGroupOptions = () =>
  [
    { label: _t("ageGroups.infant.label"), range: _t("ageGroups.infant.range"), value: "infant" },
    { label: _t("ageGroups.child.label"), range: _t("ageGroups.child.range"), value: "child" },
    { label: _t("ageGroups.adult.label"), range: _t("ageGroups.adult.range"), value: "adult" },
  ] as const

export const getCabinTypePreferences = () => [
  { label: _t("cabinTypes.inside"), value: "inside" },
  { label: _t("cabinTypes.outside"), value: "outside" },
  { label: _t("cabinTypes.balcony"), value: "balcony" },
  { label: _t("cabinTypes.suite"), value: "suite" },
]

export const getUserTitle = () => [
  { label: _t("passengerDetailsModal.mr"), value: "mr" },
  { label: _t("passengerDetailsModal.ms"), value: "ms" },
  { label: _t("passengerDetailsModal.mrs"), value: "mrs" },
  { label: _t("passengerDetailsModal.miss"), value: "miss" },
]

export const getStates = () => [
  {
    value: "AL",
    code: _t("profileScreen.statePicker.states.al.code"),
    name: _t("profileScreen.statePicker.states.al.name"),
  },
  {
    value: "AK",
    code: _t("profileScreen.statePicker.states.ak.code"),
    name: _t("profileScreen.statePicker.states.ak.name"),
  },
  {
    value: "AZ",
    code: _t("profileScreen.statePicker.states.az.code"),
    name: _t("profileScreen.statePicker.states.az.name"),
  },
  {
    value: "AR",
    code: _t("profileScreen.statePicker.states.ar.code"),
    name: _t("profileScreen.statePicker.states.ar.name"),
  },
  {
    value: "CA",
    code: _t("profileScreen.statePicker.states.ca.code"),
    name: _t("profileScreen.statePicker.states.ca.name"),
  },
  {
    value: "CO",
    code: _t("profileScreen.statePicker.states.co.code"),
    name: _t("profileScreen.statePicker.states.co.name"),
  },
  {
    value: "CT",
    code: _t("profileScreen.statePicker.states.ct.code"),
    name: _t("profileScreen.statePicker.states.ct.name"),
  },
  {
    value: "DE",
    code: _t("profileScreen.statePicker.states.de.code"),
    name: _t("profileScreen.statePicker.states.de.name"),
  },
  {
    value: "DC",
    code: _t("profileScreen.statePicker.states.dc.code"),
    name: _t("profileScreen.statePicker.states.dc.name"),
  },
  {
    value: "FL",
    code: _t("profileScreen.statePicker.states.fl.code"),
    name: _t("profileScreen.statePicker.states.fl.name"),
  },
  {
    value: "GA",
    code: _t("profileScreen.statePicker.states.ga.code"),
    name: _t("profileScreen.statePicker.states.ga.name"),
  },
  {
    value: "HI",
    code: _t("profileScreen.statePicker.states.hi.code"),
    name: _t("profileScreen.statePicker.states.hi.name"),
  },
  {
    value: "ID",
    code: _t("profileScreen.statePicker.states.id.code"),
    name: _t("profileScreen.statePicker.states.id.name"),
  },
  {
    value: "IL",
    code: _t("profileScreen.statePicker.states.il.code"),
    name: _t("profileScreen.statePicker.states.il.name"),
  },
  {
    value: "IN",
    code: _t("profileScreen.statePicker.states.in.code"),
    name: _t("profileScreen.statePicker.states.in.name"),
  },
  {
    value: "IA",
    code: _t("profileScreen.statePicker.states.ia.code"),
    name: _t("profileScreen.statePicker.states.ia.name"),
  },
  {
    value: "KS",
    code: _t("profileScreen.statePicker.states.ks.code"),
    name: _t("profileScreen.statePicker.states.ks.name"),
  },
  {
    value: "KY",
    code: _t("profileScreen.statePicker.states.ky.code"),
    name: _t("profileScreen.statePicker.states.ky.name"),
  },
  {
    value: "LA",
    code: _t("profileScreen.statePicker.states.la.code"),
    name: _t("profileScreen.statePicker.states.la.name"),
  },
  {
    value: "ME",
    code: _t("profileScreen.statePicker.states.me.code"),
    name: _t("profileScreen.statePicker.states.me.name"),
  },
  {
    value: "MD",
    code: _t("profileScreen.statePicker.states.md.code"),
    name: _t("profileScreen.statePicker.states.md.name"),
  },
  {
    value: "MA",
    code: _t("profileScreen.statePicker.states.ma.code"),
    name: _t("profileScreen.statePicker.states.ma.name"),
  },
  {
    value: "MI",
    code: _t("profileScreen.statePicker.states.mi.code"),
    name: _t("profileScreen.statePicker.states.mi.name"),
  },
  {
    value: "MN",
    code: _t("profileScreen.statePicker.states.mn.code"),
    name: _t("profileScreen.statePicker.states.mn.name"),
  },
  {
    value: "MS",
    code: _t("profileScreen.statePicker.states.ms.code"),
    name: _t("profileScreen.statePicker.states.ms.name"),
  },
  {
    value: "MO",
    code: _t("profileScreen.statePicker.states.mo.code"),
    name: _t("profileScreen.statePicker.states.mo.name"),
  },
  {
    value: "MT",
    code: _t("profileScreen.statePicker.states.mt.code"),
    name: _t("profileScreen.statePicker.states.mt.name"),
  },
  {
    value: "NE",
    code: _t("profileScreen.statePicker.states.ne.code"),
    name: _t("profileScreen.statePicker.states.ne.name"),
  },
  {
    value: "NV",
    code: _t("profileScreen.statePicker.states.nv.code"),
    name: _t("profileScreen.statePicker.states.nv.name"),
  },
  {
    value: "NH",
    code: _t("profileScreen.statePicker.states.nh.code"),
    name: _t("profileScreen.statePicker.states.nh.name"),
  },
  {
    value: "NJ",
    code: _t("profileScreen.statePicker.states.nj.code"),
    name: _t("profileScreen.statePicker.states.nj.name"),
  },
  {
    value: "NM",
    code: _t("profileScreen.statePicker.states.nm.code"),
    name: _t("profileScreen.statePicker.states.nm.name"),
  },
  {
    value: "NY",
    code: _t("profileScreen.statePicker.states.ny.code"),
    name: _t("profileScreen.statePicker.states.ny.name"),
  },
  {
    value: "NC",
    code: _t("profileScreen.statePicker.states.nc.code"),
    name: _t("profileScreen.statePicker.states.nc.name"),
  },
  {
    value: "ND",
    code: _t("profileScreen.statePicker.states.nd.code"),
    name: _t("profileScreen.statePicker.states.nd.name"),
  },
  {
    value: "OH",
    code: _t("profileScreen.statePicker.states.oh.code"),
    name: _t("profileScreen.statePicker.states.oh.name"),
  },
  {
    value: "OK",
    code: _t("profileScreen.statePicker.states.ok.code"),
    name: _t("profileScreen.statePicker.states.ok.name"),
  },
  {
    value: "OR",
    code: _t("profileScreen.statePicker.states.or.code"),
    name: _t("profileScreen.statePicker.states.or.name"),
  },
  {
    value: "PA",
    code: _t("profileScreen.statePicker.states.pa.code"),
    name: _t("profileScreen.statePicker.states.pa.name"),
  },
  {
    value: "RI",
    code: _t("profileScreen.statePicker.states.ri.code"),
    name: _t("profileScreen.statePicker.states.ri.name"),
  },
  {
    value: "SC",
    code: _t("profileScreen.statePicker.states.sc.code"),
    name: _t("profileScreen.statePicker.states.sc.name"),
  },
  {
    value: "SD",
    code: _t("profileScreen.statePicker.states.sd.code"),
    name: _t("profileScreen.statePicker.states.sd.name"),
  },
  {
    value: "TN",
    code: _t("profileScreen.statePicker.states.tn.code"),
    name: _t("profileScreen.statePicker.states.tn.name"),
  },
  {
    value: "TX",
    code: _t("profileScreen.statePicker.states.tx.code"),
    name: _t("profileScreen.statePicker.states.tx.name"),
  },
  {
    value: "UT",
    code: _t("profileScreen.statePicker.states.ut.code"),
    name: _t("profileScreen.statePicker.states.ut.name"),
  },
  {
    value: "VT",
    code: _t("profileScreen.statePicker.states.vt.code"),
    name: _t("profileScreen.statePicker.states.vt.name"),
  },
  {
    value: "VA",
    code: _t("profileScreen.statePicker.states.va.code"),
    name: _t("profileScreen.statePicker.states.va.name"),
  },
  {
    value: "WA",
    code: _t("profileScreen.statePicker.states.wa.code"),
    name: _t("profileScreen.statePicker.states.wa.name"),
  },
  {
    value: "WV",
    code: _t("profileScreen.statePicker.states.wv.code"),
    name: _t("profileScreen.statePicker.states.wv.name"),
  },
  {
    value: "WI",
    code: _t("profileScreen.statePicker.states.wi.code"),
    name: _t("profileScreen.statePicker.states.wi.name"),
  },
  {
    value: "WY",
    code: _t("profileScreen.statePicker.states.wy.code"),
    name: _t("profileScreen.statePicker.states.wy.name"),
  },
]

export const paymentRequestType = new Map<PaymentLineItemType, string>([
  [PaymentLineItemTypeEnum.CabinBooking, _t("paymentRequestType.cabinBooking")],
  [PaymentLineItemTypeEnum.Other, _t("paymentRequestType.other")],
])

export const paymentRequestStatus = new Map<
  PaymentRequestStatus,
  { label: string; roomLabel: string; statusType: string }
>([
  [
    PaymentRequestStatusEnum.Approved,
    {
      label: _t("paymentRequestStatus.approved"),
      roomLabel: _t("paymentRequestStatus.approvedRoom"),
      statusType: "success",
    },
  ],
  [
    PaymentRequestStatusEnum.CancelledByAgent,
    {
      label: _t("paymentRequestStatus.cancelledByAgent"),
      roomLabel: _t("paymentRequestStatus.cancelledByAgentRoom"),
      statusType: "error",
    },
  ],
  [
    PaymentRequestStatusEnum.PartiallyPaid,
    {
      label: _t("paymentRequestStatus.partiallyPaid"),
      roomLabel: _t("paymentRequestStatus.partiallyPaidRoom"),
      statusType: "warning",
    },
  ],
  [
    PaymentRequestStatusEnum.RejectedByUser,
    {
      label: _t("paymentRequestStatus.rejectedByUser"),
      roomLabel: _t("paymentRequestStatus.rejectedByUserRoom"),
      statusType: "error",
    },
  ],
  [
    PaymentRequestStatusEnum.RequiresPaymentMethod,
    {
      label: _t("paymentRequestStatus.requiresPaymentMethod"),
      roomLabel: _t("paymentRequestStatus.requiresPaymentMethodRoom"),
      statusType: "warning",
    },
  ],
  [
    PaymentRequestStatusEnum.TotalPaid,
    {
      label: _t("paymentRequestStatus.totalPaid"),
      roomLabel: _t("paymentRequestStatus.totalPaidRoom"),
      statusType: "success",
    },
  ],
  [
    PaymentRequestStatusEnum.Confirmed,
    {
      label: _t("paymentRequestStatus.confirmed"),
      roomLabel: _t("paymentRequestStatus.confirmedRoom"),
      statusType: "success",
    },
  ],
])

export const paymentPlanStatus = new Map<PaymentPlan, string>([
  [PaymentPlanEnum.Total, _t("paymentPlanStatus.total")],
  [PaymentPlanEnum.TotalSplit, _t("paymentPlanStatus.totalSplit")],
  [PaymentPlanEnum.DepositOnly, _t("paymentPlanStatus.depositOnly")],
  [
    PaymentPlanEnum.DepositWithAutoFinalPayment,
    _t("paymentPlanStatus.depositWithAutoFinalPayment"),
  ],
])
